import Flex from '@eversports/react-components/primitives/Flex'
import MenuItem from '@eversports/react-components/primitives/MenuItem'
import Select from '@eversports/react-components/primitives/Select'
import TextField from '@eversports/react-components/primitives/TextField'
import React from 'react'

import useCountries from '../../../data/useCountries'
import { Localized } from '../../../localization/react'

const Address: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { countries, isLoading } = useCountries()

  return (
    <Flex key="address" flexDirection="column" verticalSpacing="default">
      <TextField
        name="street"
        label={<Localized id="field-street" />}
        fullWidth
        required
        data-testid="required-information-address-street"
      />
      <TextField
        name="detail"
        label={<Localized id="field-detail" />}
        fullWidth
        required
        data-testid="required-information-address-detail"
      />
      <TextField
        name="zip"
        label={<Localized id="field-zip" />}
        fullWidth
        required
        data-testid="required-information-address-zip"
      />
      <TextField
        name="city"
        label={<Localized id="field-city" />}
        fullWidth
        required
        data-testid="required-information-address-city"
      />
      <Select
        name="country"
        label={<Localized id="field-country" />}
        fullWidth
        required
        disabled={isLoading}
        data-testid="required-information-address-country"
      >
        {countries &&
          countries.map((country) => (
            <MenuItem
              value={country.iso}
              key={country.iso}
              data-testid={`required-information-address-country-${country.iso.toUpperCase()}`}
            >
              {country.name}
            </MenuItem>
          ))}
      </Select>
    </Flex>
  )
}

export default Address
